<template>
    <div class="ReExportRulesValues" >
       <table class="rules">
        <thead><tr><th><p>Значение</p></th><th><p>Условия</p></th></tr></thead>
        <tbody>
            <tr v-for="(rule,index) of localRules" :key="index">
                <td>
                    <el-input class="required" placeholder="значение" v-model="rule.val" style="width: 170px;"></el-input>
                </td>
                <td style="width: 100%;">
                    <ReObjFilter v-model="rule.flt"/>
                </td>
                <td><base-button @click="delRule(index)" class="btn btn-icon btn-danger my-0"><i class="tim-icons icon-trash-simple"></i></base-button></td>
            </tr>
        </tbody>
       </table>
       <base-button @click="addRule" class="btn btn-simple btn-success my-0">Добавить</base-button>
    </div>
</template>
<script>
import Vue from 'vue';
import ReObjFilter from './ReObjFilter.vue';

    // import { Select, Option } from 'element-ui';
    export default {
		name: 'ReExportRulesValues',
		components: {
            // [Option.name]: Option,
            // [Select.name]: Select,
            ReObjFilter
		},
		props: {
			value: String,
            pretty:{
                type:Boolean,
                default: false,
            }
        },
        data () {
			return {
				ver: 1,
				localRules:[],
                editor:[],
			}
		},
        watch:{
            value(){
                try{
                    // this.localRules = JSON.parse(this.value);
                    this.readRules();
                }catch(e){
                    console.error(e);
                    this.localRules = [];
                }
            },
            
            outRules(value){
                // console.log('exportRulesValues change',value);
                this.$emit('input', value)
                // setTimeout(()=>{this.$emit('input', value)},1000)
                
            },
            /*
            localRules:{
                deep:true,
                handler(){
                    console.log('change local',this.outRules);
                    this.$emit('input', this.outRules)
                }
            },
            */
        },
        computed:{
            /*
            textRules(){
                if(this.localRules.lenth==0) return 'Нет';
                let o,v,l;
                return (this.localRules.map(r=>{
                    o=[];
                    r.forEach(row => {
                        v=[].concat(row.values);
                        l=v.pop();
                        // o[row.catalog] = row.values
                        if(this.catalogs[row.catalog]){
                            o.push((this.catalogs[row.catalog].name)+': '+(
                                v.length>0?v.map(i=>this.catalogs[row.catalog].list[i]).join(', ')+' и ':''
                            )+this.catalogs[row.catalog].list[l])
                        }
                    });
                    return o.join('; ');
                })).join('\n')
            },
            */
            outRules(){
                // console.log('ExportRulesValues outRules', JSON.stringify(this.localRules));
                if(this.localRules.lenth==0) return '[]';
                let o={};
                this.localRules
                    .filter(r=>r.val>'')
                    .forEach(rule=>{o[rule.val] = rule.flt?JSON.parse(rule.flt):[]})
                // console.log(o)
                return JSON.stringify(o,null,this.pretty?2:null)
            }
        },
        methods:{
            /*
            open(){
                this.isOpen=true;
            },
            close(){
                this.isOpen=false;
                let value = this.outRules;
                this.$emit('input', value);
            },
            */
            delRule(i){
                this.localRules.splice(i,1);
            },
            readRules(){
                try{
                    // console.log('exportRulesValuse read', this.value);
                    let rules=this.value;
                    if(rules>'') rules=JSON.parse(rules);
                    else rules=[];
                    // console.log(rules);
                    this.localRules = Object.keys(rules).map(key=>({val:key,flt:JSON.stringify(rules[key])}))
                }catch(e){
                    console.error(e);
                }
            },
            
            addRule(){
                this.localRules.push({val:'',flt:'[]'});
                this.outRules;
            },
            
        },
        mounted(){
            // this.loadFilters();
            this.readRules();
        }
    }
</script>
<style scoped>
.rules {width: 100%;}
.rules td {
  vertical-align: top;
}
</style>